<div *ngIf="isMobile() && mapLoaded()" class="map-header-container" [ngClass]="isMobile() ? 'map-header-responsive' : ''">
    <div  class="title-container" >
        <button *ngIf="!isMobile(); else mobileButton" mat-fab extended color="primary" (click)="sidenavOpened.set(!sidenavOpened())" class="settings-button">
            <mat-icon  fontIcon="settings"></mat-icon>
            {{'map.options' | transloco}}
        </button>
        <img src="assets/img/logo-concello.png" alt="logo Concello">
        <h4 class="planificator-title">{{'routeForm.planificatorTitle' | transloco}} </h4>
    </div>
    <form *ngIf="!showingResults() && !loadingRouteResults()" [formGroup]="mapHeaderForm" class="autocomplete-container">
        <mat-form-field class="autocomplete-field" appearance="outline">
            <input type="text" [placeholder]="'map.whereYouGoing' | transloco" aria-label="Address" matInput formControlName="to" [matAutocomplete]="toAutocomplete" #trigger="matAutocompleteTrigger">
            <button [disabled]="loading || loadingRouteResults()" *ngIf="mapHeaderForm.controls.to.value" (click)="cleanFromButtonClicked(toAutocomplete)" matSuffix mat-icon-button aria-label="Change values">
                <mat-icon>clear</mat-icon>
              </button>
            <mat-icon class="autocomplete-icon" matPrefix>search</mat-icon>
            <mat-autocomplete #toAutocomplete="matAutocomplete">
                <mat-option class="search-icon search-option" *ngFor="let option of toOptions" [value]="option.properties.name" (onSelectionChange)="onOptionSelected(option)">
                    <mat-icon class="place-icon" fontIcon="place"></mat-icon>{{option.properties.name}}
                </mat-option>
                <mat-divider *ngIf="toOptions.length > 0"></mat-divider>
                <mat-option class="default-option" (onSelectionChange)="routeOptionsClicked(toAutocomplete)"><mat-icon class="place-icon" fontIcon="settings"></mat-icon>{{'routeForm.routeOptions' | transloco}}</mat-option>
                <mat-option class="default-option" (onSelectionChange)="pickOnMap(toAutocomplete)"><mat-icon class="place-icon" fontIcon="map"></mat-icon>{{'routeForm.pickOnMap' | transloco}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>

</div>

<ng-template #mobileButton>
    <button  mat-mini-fab color="primary" (click)="sidenavOpened.set(!sidenavOpened())" class="settings-button mobile-settings-button">
        <mat-icon fontIcon="settings"></mat-icon>
    </button>
</ng-template>